const REQUIRED_INVESTMENT_TYPES = new Set(['Technology Due Diligence', 'IT M&A Advisory', 'Due Diligence & Integration']);

const INVESTING_CLIENT_LABEL = 'Investing / Client Organisation';
const CLIENT_LABEL = 'Client Organisation';

export function getCreateStep1FieldPolicy(projectType) {
    const type = (projectType || '').trim();
    if (REQUIRED_INVESTMENT_TYPES.has(type)) {
        return { investmentType: 'required', investorLabel: INVESTING_CLIENT_LABEL, showInvestor: true };
    }
    return { investmentType: 'hidden', investorLabel: CLIENT_LABEL, showInvestor: false };
}

export function shouldShowInvestmentType(policy) {
    return policy?.investmentType === 'required' || policy?.investmentType === 'optional';
}
